import { entityFilterForm } from "theme/styles/variables/crossComponent";

export default `
  .notes-group-filter {
    flex-basis: ${entityFilterForm.selectMinWidth};
    flex-grow: 1;
    width: 100%;
  }
`;
